import { ListItem, ListItemAvatar, ListItemButton, ListItemText, IconButton } from "@mui/material";
import { Avatar } from "rsuite";
import ClearIcon from '@mui/icons-material/Clear';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import CelebrationIcon from '@mui/icons-material/Celebration';
import SchoolIcon from '@mui/icons-material/School';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

function AbsenceItem(props) {

    function createAbsenceInformation(typ, length, hourObject, minuteObject, isTerminatedTime) {
        let minuteText;
        if(minuteObject === null){
            minuteText = " ";
        } else minuteText = minuteObject + "min ";

        let totalTimeText;
        if(minuteObject === null){
            totalTimeText = length * hourObject + "h"
        } else {
            let totalInMinutes = (hourObject * 60 + parseInt(minuteObject)) * length;
            let newTotalHours = Math.floor(totalInMinutes / 60);
            let newTotalMinutes = totalInMinutes % 60;

            totalTimeText = newTotalHours + "h" + newTotalMinutes + "min";
        }

        if (isTerminatedTime)
            return "Terminiert: " + typ + length + " Tag(e) à " + hourObject + "h" + minuteText + "(" + totalTimeText + ")";
        else
            return "Nicht terminiert: " + typ + length + " Tag(e) à " + hourObject + "h" + minuteText + "(" + totalTimeText + ")";
    }

    function listIcon(){
        switch(props.absenceType){
            case "vacation":
                return <BeachAccessIcon fontSize="small" />
            case "illness":
                return <HealthAndSafetyIcon fontSize="small" />
            case "child_sick":
                return <ChildCareIcon fontSize="small" />
            case "holiday":
                return <CelebrationIcon fontSize="small" />
            case "further_education":
                return <LightbulbIcon fontSize="small" />
            case "vocational_school":
                return <SchoolIcon fontSize="small" />
            case "university":
                return <SchoolIcon fontSize="small" />
            case "school":
                return <SchoolIcon fontSize="small" />
            case "other":
                return <MoreHorizIcon fontSize="small" />
            default:
                return;
        }
    }

    function listText(){
        if(props.paid){
            switch(props.absenceType){
                case "vacation":
                    return createAbsenceInformation("Bezahlter Urlaub: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "illness":
                    return createAbsenceInformation("Bezahlte Krankheitstage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "child_sick":
                    return createAbsenceInformation("Bezahlte Kindkranktage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "holiday":
                    return createAbsenceInformation("Bezahlte Feiertage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "further_education":
                    return createAbsenceInformation("Bezahlte Weiterbildung: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "vocational_school":
                    return createAbsenceInformation("Bezahlte Berufsschultage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "university":
                    return createAbsenceInformation("Bezahlte Universitätstage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "school":
                    return createAbsenceInformation("Bezahlte Schultage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "other":
                    return createAbsenceInformation("Bezahlte Sonstigetage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                default:
                    return;
            }
        } else {
            switch(props.absenceType){
                case "vacation":
                    return createAbsenceInformation("Unbezahlter Urlaub: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "illness":
                    return createAbsenceInformation("Unbezahlte Krankheitstage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "child_sick":
                    return createAbsenceInformation("Unbezahlte Kindkranktage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "holiday":
                    return createAbsenceInformation("Unbezahlte Feiertage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "further_education":
                    return createAbsenceInformation("Unbezahlte Weiterbildung: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "vocational_school":
                    return createAbsenceInformation("Unbezahlte Berufsschultage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "university":
                    return createAbsenceInformation("Unbezahlte Universitätstage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "school":
                    return createAbsenceInformation("Unbezahlte Schultage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                case "other":
                    return createAbsenceInformation("Unbezahlte Sonstigetage: ", props.length, props.hourObject, props.minuteObject, props.isTerminatedTime);
                default:
                    return;
            }
        }

    }

    return (
        <ListItem
            secondaryAction={
            <IconButton edge="end" onClick={props.listOnClick}>
                <ClearIcon color="error" />
            </IconButton>
        }
        disablePadding
        >
            <ListItemButton onClick={props.isTerminatedTime ? props.itemButtonOnClick : () => {}}>
                    <ListItemAvatar>
                        <Avatar>
                            {listIcon()}
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                        {listText()}
                    </ListItemText>
            </ListItemButton>
        </ListItem>
    )
} 

export default AbsenceItem;